export default __webpack_public_path__ + "img/1f48a6d38fd18ca613e1d69533d232b6.png";